
export function BPMRedirect(props: { to: string }) {
    window.location.replace(props.to)
    return null;
}